import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { gridTheme } from '@utils/grid';
import { Button } from '@common/components';
import { CloseModalButton, Header, MobileHeading } from '@common/components/BookingForms';
import { useIsWindowWiderThan } from '@common/hooks';
import { Modal } from '../Filters';

import { MobileContainer, MobileInnerContainer } from '../JourneyPicker.styles';

type MobileModalPickerProps = {
  children?: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (boolean) => void;
};

export const MobileModal: FC<MobileModalPickerProps> = ({ children, isOpen, setIsOpen }) => {
  const { t } = useTranslations();
  const isWiderViewport = useIsWindowWiderThan(gridTheme.breakpoints.md);

  return isWiderViewport ? (
    <>{children}</>
  ) : (
    <>
      <MobileContainer>
        <Button onClick={() => setIsOpen(!isOpen)} isSmall>
          {t('spaClasses.changeSearch')}
        </Button>
        <Modal isVisible={isOpen}>
          <Header>
            <MobileHeading>{t('spaClasses.filters')}</MobileHeading>
            <CloseModalButton onClick={() => setIsOpen(false)} />
          </Header>
          <MobileInnerContainer>{children}</MobileInnerContainer>
        </Modal>
      </MobileContainer>
    </>
  );
};
